import { Component, Input, OnInit } from 'angular-ts-decorators';

/**
 * Displays a Google map iframe with mouse functionality initially disabled
 *
 * # Example
 * <pre>
 *   <sw-google-maps map-url="https://..."></sw-google-maps>
 * </pre>
 */
@Component({
  selector: 'swGoogleMaps',
  template: require('./sw-google-maps.html').default,
})
export class SwGoogleMapsComponent implements OnInit {
  @Input('@') mapUrl: string;
  shouldHandleClickEvents: boolean;

  constructor(private $sce: ng.ISCEService) {
    'ngInject';
  }

  ngOnInit() {
    this.shouldHandleClickEvents = false;
  }

  trustUrl(url: string): any {
    return this.$sce.trustAsResourceUrl(url);
  }

  toggleClickEvents(state: boolean): void {
    this.shouldHandleClickEvents = state;
  }
}
